import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Headline, Text } from '@/components/typography';
type StepSectionProps = {
  title: string;
  anchorKey?: string;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
};
export const StepSection = t0 => {
  const $ = _c(11);
  const {
    title,
    anchorKey,
    subtitle,
    children
  } = t0;
  let t1;
  if ($[0] !== anchorKey || $[1] !== title) {
    t1 = <Headline as="h3" variant="h4" anchorKey={anchorKey}>{title}</Headline>;
    $[0] = anchorKey;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== subtitle) {
    t2 = subtitle && <Text>{subtitle}</Text>;
    $[3] = subtitle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col items-start gap-4 text-left md:items-center md:text-center">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== t3) {
    t4 = <section className="flex flex-col gap-10">{t3}{children}</section>;
    $[8] = children;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};